var _path, _path2, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5086 16.3202C18.4823 16.2939 18.4675 16.2582 18.4675 16.221C18.4675 16.1838 18.4823 16.1481 18.5086 16.1218L23.6992 10.9318C24.0274 10.6032 24.027 10.0707 23.6983 9.74248C23.3697 9.41429 22.8372 9.41466 22.509 9.74332L17.319 14.931C17.2927 14.9574 17.257 14.9722 17.2198 14.9722C17.1826 14.9722 17.1469 14.9574 17.1207 14.931L11.9307 9.74332C11.6025 9.41497 11.0703 9.41485 10.7419 9.74304C10.4136 10.0712 10.4134 10.6035 10.7416 10.9318L15.931 16.1218C15.9574 16.1481 15.9722 16.1838 15.9722 16.221C15.9722 16.2582 15.9574 16.2939 15.931 16.3202L10.7416 21.5107C10.5293 21.7231 10.4465 22.0326 10.5243 22.3227C10.6021 22.6127 10.8287 22.8393 11.1188 22.9169C11.4089 22.9946 11.7184 22.9116 11.9307 22.6992L17.1207 17.5087C17.1469 17.4823 17.1826 17.4675 17.2198 17.4675C17.257 17.4675 17.2927 17.4823 17.319 17.5087L22.509 22.6992C22.8372 23.0275 23.3694 23.0277 23.6978 22.6995C24.0261 22.3713 24.0262 21.839 23.698 21.5107L18.5086 16.3202Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5053_65359",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5086 16.3202C18.4823 16.2939 18.4675 16.2582 18.4675 16.221C18.4675 16.1838 18.4823 16.1481 18.5086 16.1218L23.6992 10.9318C24.0274 10.6032 24.027 10.0707 23.6983 9.74248C23.3697 9.41429 22.8372 9.41466 22.509 9.74332L17.319 14.931C17.2927 14.9574 17.257 14.9722 17.2198 14.9722C17.1826 14.9722 17.1469 14.9574 17.1207 14.931L11.9307 9.74332C11.6025 9.41497 11.0703 9.41485 10.7419 9.74304C10.4136 10.0712 10.4134 10.6035 10.7416 10.9318L15.931 16.1218C15.9574 16.1481 15.9722 16.1838 15.9722 16.221C15.9722 16.2582 15.9574 16.2939 15.931 16.3202L10.7416 21.5107C10.5293 21.7231 10.4465 22.0326 10.5243 22.3227C10.6021 22.6127 10.8287 22.8393 11.1188 22.9169C11.4089 22.9946 11.7184 22.9116 11.9307 22.6992L17.1207 17.5087C17.1469 17.4823 17.1826 17.4675 17.2198 17.4675C17.257 17.4675 17.2927 17.4823 17.319 17.5087L22.509 22.6992C22.8372 23.0275 23.3694 23.0277 23.6978 22.6995C24.0261 22.3713 24.0262 21.839 23.698 21.5107L18.5086 16.3202Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5053_65359)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 6.5,
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.3e0f0632f8a3bab4eebdb54a153037d8.svg";
export { ForwardRef as ReactComponent };